import { apiGet, apiPost, apiPatch, apiDelete } from '@/app/api/core/http';
import { CAT_PATENT_CITATIONS } from 'App/utils/Collections';
import { PATENTS_PATHS } from './paths';

export const patentsApiAdapter = {
  getPatents: (params, ld = true, headers) => {
    const { clearParams, ...rest } = params;
    let url = PATENTS_PATHS.patents;
    if (ld) {
      url += PATENTS_PATHS.suffix;
    }
    let preparedParams = {
      params: rest,
      clearParams,
      is_protected: true,
    };
    if (headers) {
      preparedParams.headers = headers.headers;
    }
    return apiGet(url, preparedParams);
  },
  getPatentDetails: (id, headers) => {
    if (headers) {
      return apiGet(`${PATENTS_PATHS.patents}/${id}`, {
        headers: headers,
        is_protected: true,
      });
    } else {
      return apiGet(`${PATENTS_PATHS.patents}/${id}`, { is_protected: true });
    }
  },
  getPatentContents: (params) => apiGet(PATENTS_PATHS.contents + PATENTS_PATHS.suffix, { params }),
  getPatentDescriptions: (params) => apiGet(PATENTS_PATHS.descriptions + PATENTS_PATHS.suffix, { params }),
  getPatentClaims: (params) => apiGet(PATENTS_PATHS.claims + PATENTS_PATHS.suffix, { params }),
  createPatent: (data) => apiPost(PATENTS_PATHS.explore, { data, is_protected: true }),
  createPatentInternalNote: (data) => apiPost(PATENTS_PATHS.internalNotes, { data }),
  getPatentInternalNotes: (params) => apiGet(PATENTS_PATHS.internalNotes, { params }),
  deletePatentInternalNote: (id) => apiDelete(`${PATENTS_PATHS.internalNotes}/${id}`),
  updatePatentInternalNote: (id, data) => apiPatch(`${PATENTS_PATHS.internalNotes}/${id}`, { data }),
  [CAT_PATENT_CITATIONS]: {
    getList: (params) => apiGet(`${PATENTS_PATHS.citations}`, { params }),
  },
  loadPatentLegalEvents: (patentID) => apiGet(`${PATENTS_PATHS.legalEventsBase}/${patentID}/legal_events`),
  cpcClassifications: {
    getList: (params) => apiGet(PATENTS_PATHS.cpcClassifications, { params }),
  },
  ipcClassifications: {
    getList: (params) => apiGet(PATENTS_PATHS.ipcClassifications, { params }),
  },
};

export const patentsFilterAdapter = {
  getCpcClassification: (params) => apiGet(PATENTS_PATHS.cpcClassification, params),
  getIpcClassification: (params) => apiGet(PATENTS_PATHS.ipcClassification, params),
};
